import { OnInit, Component, ViewChild } from '@angular/core';
import { IJobAlertSettings } from '../../interfaces/job-alert-settings';
import { JobAlertService, OrganisationSettingService, UserService } from '../../services';
import { compare } from 'fast-json-patch';
import { JobAlertSettingsEditComponent } from './job-alert-settings-edit.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OrganisationSettingEnum } from '../../enums/organisation-settings';
import { Dialog } from 'primeng';
import { Message } from 'src/app/classes/Message';
import { Router } from '@angular/router';

@Component({
  selector: 'job-alert-settings-supplier',
  templateUrl: './job-alert-settings-supplier.component.html',
  styleUrls: ['./job-alert-settings-supplier.component.scss'],
})
export class JobAlertSettingsSupplierComponent implements OnInit {
  @ViewChild(JobAlertSettingsEditComponent) editComponent;

  public editMode: boolean = false;
  public alertSettingList: IJobAlertSettings[] = [];
  public settingsLoaded: boolean = false;
  public reminderSettings: {
    id?: number;
    icon: string;
    type: string;
    description: string;
    enabled: boolean;
    setting: number;
  }[] = [];
  private orgSettings: {};
  private currentOrgId: number = null;
  itemChosen: any;
  public showDisableSMS: boolean;
  public showDisableEmail: boolean;

  constructor(
    private router: Router,
    private jobAlertService: JobAlertService,
    private confirmationService: ConfirmationService,
    private organisationSettingService: OrganisationSettingService,
    private userService: UserService,
    private messageService: MessageService,
  ) {}

  async ngOnInit() {
    this.userService.getCurrentUserOrg().then((currentOrg) => {
      this.currentOrgId = currentOrg.id;

      this.getOrganisationSettings(this.currentOrgId);
    });
  }

  getOrganisationSettings(orgId: number) {
    this.organisationSettingService
      .search({
        organisationId: orgId,
        includeOrganisation: false,
        component: 'job-alert-settings-supplier',
      })
      .then((x) => {
        this.orgSettings = this.organisationSettingService.parseSettings(x);

        const sendByEmail =
          OrganisationSettingEnum.JobAlertsByMail in this.orgSettings
            ? this.orgSettings[OrganisationSettingEnum.JobAlertsByMail].intValue == 1
            : true;

        const sendBySMS =
          OrganisationSettingEnum.JobAlertsBySMS in this.orgSettings
            ? this.orgSettings[OrganisationSettingEnum.JobAlertsBySMS].intValue == 1
            : false;

        this.reminderSettings = [
          {
            icon: 'fa-envelope-o',
            type: 'Email',
            description: 'Receive email notifications about the details of your upcoming jobs',
            enabled: sendByEmail,
            id: this.orgSettings[OrganisationSettingEnum.JobAlertsByMail]?.id,
            setting: OrganisationSettingEnum.JobAlertsByMail,
          },
          {
            icon: 'fa-comment-o',
            type: 'SMS',
            description:
              'Receive text message notifications about the details of your upcoming jobs',
            setting: OrganisationSettingEnum.JobAlertsBySMS,
            id: this.orgSettings[OrganisationSettingEnum.JobAlertsBySMS]?.id,
            enabled: sendBySMS,
          },
        ];
      });
  }

  newAlertSetting(alertName: string) {
    this.editComponent.newAlertSetting(alertName);
  }

  editAlertSetting(id: number) {
    this.jobAlertService.getSetting(id).then((x) => {
      this.editComponent.editAlertSetting(x);
    });
  }

  deleteSelected(id: number) {
    console.log('CONFIRMING');
    this.confirmationService.confirm({
      message: 'Delete this alert?',
      header: 'Confirm',
      accept: () => {
        this.deleteSetting(id).then(() => {
          this.messageService.add(Message.Success('Deleted sucessfully'));
        });
      },
    });
  }

  async deleteSetting(id: number) {
    await this.jobAlertService.deleteSetting(id);
    await this.getSupplierSettings();
  }

  async getSupplierSettings() {
    this.jobAlertService.getSupplierSettings().then((x: IJobAlertSettings[]) => {
      this.settingsLoaded = true;

      if (x.length > 0) {
        this.alertSettingList = x;
      } else {
        // Mimic a dummy alert
        this.alertSettingList = [{ id: null, settingName: 'Default Settings', enabled: true }];
      }

      this.alertSettingList.map(
        (x) =>
          (x.enabled = x.dateTo != null && new Date(x.dateTo) <= new Date() ? false : x.enabled),
      );

      this.alertSettingList.map(
        (x) => (x.canEdit = !x.followOnMovements && !x.returnJourneyMovements),
      );
    });
  }

  async enableChanged(event, item) {
    let oldDTO = { enabled: !item.enabled };
    let newDTO = { enabled: item.enabled };

    const patch = compare(oldDTO, newDTO);

    await this.jobAlertService.patchSetting(item.id, patch);
  }

  async editModeChange($event: boolean) {
    this.editMode = $event;

    if (this.editMode == false) {
      await this.getSupplierSettings();
    }
  }

  disabledSwitch(item: any) {
    return item && item.dateTo != null && new Date(item.dateTo) <= new Date();
  }

  disabledReminderSwitch(item: any) {
    return false;
  }

  enableReminderChanged($event: any, item: any) {
    this.itemChosen = item;

    if (item.enabled == false) {
      if (item.setting == OrganisationSettingEnum.JobAlertsByMail) {
        this.showDisableEmail = true;
      } else {
        this.showDisableSMS = true;
      }
    } else {
      this.showDisableEmail = false;
      this.showDisableSMS = false;

      this.changeReminderSetting(item);
    }
  }

  changeReminderSetting(item) {
    this.showDisableSMS = false;
    this.showDisableEmail = false;

    if (item.id) {
      var patch = compare({}, { intValue: item.enabled ? 1 : 0 });
      this.organisationSettingService.patch(item.id, patch).then(() => {});
    } else {
      this.organisationSettingService
        .create({
          organisationId: this.currentOrgId,
          intValue: item.enabled ? 1 : 0,
          setting: item.setting,
        })
        .then((o) => {
          item.id = o.id;
        });
    }
  }
}
